export const selectRoleBasedSigningSchema = ({ roleBasedSigningSchema }) => roleBasedSigningSchema;
